import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface TestimonialCardProps {
  name: string;
  location: string;
  image: string;
  alt: string;
  rating: number;
  service: string;
  testimonial: string;
  date: string;
}

const TestimonialCard = ({
  name,
  location,
  image,
  alt,
  rating,
  service,
  testimonial,
  date,
}: TestimonialCardProps) => {
  return (
    <div className="bg-card rounded-lg shadow-soft p-6 hover:shadow-elevated transition-shadow duration-base">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
          <AppImage
            src={image}
            alt={alt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h4 className="font-headline font-bold text-primary">{name}</h4>
          <p className="text-sm text-text-secondary">{location}</p>
          <div className="flex items-center space-x-1 mt-1">
            {[...Array(5)].map((_, index) => (
              <Icon
                key={index}
                name="StarIcon"
                size={16}
                variant="solid"
                className={
                  index < rating ? 'text-accent' : 'text-text-secondary/30'
                }
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mb-3">
        <span className="inline-block px-3 py-1 bg-muted rounded-full text-xs font-semibold text-text-secondary">
          {service}
        </span>
      </div>

      <p className="text-text-primary mb-4 leading-relaxed">{testimonial}</p>

      <div className="flex items-center justify-between text-sm text-text-secondary">
        <span>{date}</span>
        <div className="flex items-center space-x-1">
          <Icon name="CheckBadgeIcon" size={16} variant="solid" className="text-success" />
          <span>Verified Customer</span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;